import React, {useEffect, useMemo, useState} from "react";
import {
    Box,
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, MenuItem, Select,
    TextField,
    Typography,
    CircularProgress
} from "@mui/material";
import "../App.css";
import { useNavigate } from "react-router-dom";
import message from "../data.js";
import ApiClient from "../sdk/ApiClient";
import {useKeycloak} from "@react-keycloak/web";
import {useLocation } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";

const SendCampaign = () => {
    const location = useLocation();
    const {keycloak} = useKeycloak();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const from = searchParams.get("from");

    const intro= message.intro;
    const link = message.link;
    const signature = message.signature;
    const [finalText, setFinalText] = useState("");
    const [description, setDescription] = useState("");
    const [open, setOpen] = useState(false);        // affichage de la popup présentant le bilan
    const [sending, setSending] = useState(false);  // affichage de la popup envoi en cours
    const [campaign , setCampaign] = useState(null);

    const [template, setTemplate] = useState(0);
    const [sendCount, setSendCount] = useState(0);
    const [sendSuccessCount, setSendSuccessCount] = useState(0);
    const [sendErrorCount, setSendErrorCount] = useState(0);

    const apiClientInstance = useMemo(() => new ApiClient(keycloak.token), [keycloak.token]);

    useEffect(() => {
        console.log("SendCampaign useEffect - campaign " + JSON.stringify(campaign));
    }, [campaign])

    useEffect(() => {

        // ce code permet, en cas de refresh de la page, d'aller récupérer la campagne stockée dans le local storage
        // on fait cela car on récupère la campagne via uselocation ( et en cas de F5, on perd l'information)
        if(location.state) {
            setCampaign(location.state);
            localStorage.setItem("campaign", JSON.stringify(location.state));
        }
        else
        {
            const localStorageCampaign = localStorage.getItem("campaign");
            if (localStorageCampaign) {
                try {
                    setCampaign(JSON.parse(localStorageCampaign));
                } catch (e) {
                    console.error("Erreur lors dela récupération de la campagne dans le local storage", e);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let tmp= "Bonjour {firstname},\n\n" + intro + "\n\n";
        if(template === 1) {
            tmp += (description == null ? "{description}" : description) + "\n\n"
        }
        tmp += link + "\n\n" + signature;
        if(campaign) {
            tmp = tmp.replace("{mission_title}", campaign.mission.label)
            tmp = tmp.replace("{mission_link}", campaign.mission.url)
        }
        if(tmp.length> 1012)
        {
            const nbCarTodelete = tmp.length - 1012;
            setDescription(description.substring(0, description.length -  nbCarTodelete));
        }
        setFinalText(tmp)
    }, [campaign, template, description, link, signature, intro]);

    const onClickBack = () => {

        navigate(`/` + from + `?missionId=` + campaign.mission.id);
    }

    const onClickNext = async () => {
        try {

            const campaignData = {
                missionId: campaign.mission.id,
                membersId:campaign.membersId,
                groupsId: campaign.groupsId,
                description: description,
                signature: signature,
                hasDescription: (template === 1)
            }

            setSending(true);

            await apiClientInstance.sendCampaign(campaignData)
                .then((result) => {
                    // Traitement du résultat ici
                    // console.log("Résultat reçu :", result);
                    setSendCount(result.length);
                    setSendErrorCount(result.filter(r => r.sendState === "ERROR").length)
                    setSendSuccessCount(result.filter(r => r.sendState === "OK").length)

                    // Suppression de la campagne dans le local storage
                    localStorage.removeItem("campaign");
                })
                .catch((error) => {
                    // Gestion des erreurs
                    console.error("Erreur lors de l'envoi de la campagne :", error);
                })
                .finally(() => {
                    // Code exécuté dans tous les cas (succès ou échec)
                    setOpen(true);
                    setSending(false);
                });
        } catch (error) {
            console.error("retour de sendCampaign" + error);
        }
    }

    const handleRedirect = () => {
        navigate("/missions"); // Redirection vers /missions
    };

    const sanitizeDescription = (descriptionCandidate : string) => {

        if (!descriptionCandidate) {
            setDescription("");
            return;
        }
        const sanitized = descriptionCandidate
            // Supprime les retours à la ligne
            .replace(/[\r\n]+/g, "")
            // Remplace les tabs éventuels par des espaces
            .replace(/[^\S\r\n]/g, " ")
            // Limite à 4 espaces consécutifs max
            .replace(/ {5,}/g, "    ")
            ;

        setDescription(sanitized);
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", padding:5 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    textAlign: "center",
                }}
            >
                <Button name={"back"} variant="outlined" onClick={onClickBack}>PRECEDENT</Button>
                <Typography variant="h4">Définition du corps de message</Typography>
                <Button name={"next"} variant="outlined" onClick={onClickNext} > ENVOYER</Button>
            </Box>
            <Box id={"group_selection_box"} display="flex" sx={{overflowY: "hidden", paddingTop:2}}>
                    {/* Colonne de gauche */}
                    <Box
                        flex={1}
                        paddingRight={2}
                        borderRight="1px solid #ddd"
                        sx={{overflowY: "auto"}}
                        height={"75vh"}
                    >
                        <Typography variant="h5">Choix du modèle</Typography>
                        <Select
                            id="select-template"
                            value={template}
                            label="Modèle"
                            onChange={(e) => setTemplate(e.target.value)}
                            variant={"outlined"}
                        >
                            <MenuItem value={0}>Modèle simple, sans description</MenuItem>
                            <MenuItem value={1}>Modèle avec description</MenuItem>
                        </Select>
                        <Typography variant="h5">Saisie du message</Typography>
                        <TextField
                            multiline={true}
                            rows={5}
                            variant="outlined"
                            fullWidth
                            value={description}
                            onChange={(event) => sanitizeDescription(event.target.value)
                            }
                        ></TextField>
                    </Box>
                    {/* Colonne de droite */}
                    <Box flex={1}
                         paddingLeft={2}
                         sx={{overflowY: "auto"}}
                         height={"75vh"}
                    >
                        <Typography variant="h5">Message envoyé</Typography>
                        <TextField
                            aria-readonly={true}
                            multiline={true}
                            rows={15}
                            variant="outlined"
                            fullWidth
                            value={finalText}
                            readOnly={true}
                        ></TextField>
                        <Box fullWidth >
                            {finalText.length >= 1012 ?
                                <Typography textAlign={"right"} variant="h5" color={"red"}>{finalText.length}/1012</Typography>:
                                (finalText.length >= 800 ?
                                    <Typography textAlign={"right"} variant="h5" color={"orange"}>{finalText.length}/1012</Typography>:
                                    <Typography textAlign={"right"} variant="h5" color={"green"}>{finalText.length}/1012</Typography>)
                            }
                        </Box>
                </Box>
            </Box>
            <Dialog open={sending} >
                <DialogTitle>Campagne en cours d'envoi</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                        <CircularProgress/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {/* Bouton pour retourner à /missions */}
                    <Button onClick={handleRedirect} color="primary">
                        Envoyer une nouvelle campagne
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={open} onClose={handleRedirect}>
                <DialogTitle>Campagne envoyée</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Votre campagne a été envoyée avec succès !<br/>
                        - Nombre total d'envois : {sendCount}<br/>
                        - Nombre d'envois réussis : {sendSuccessCount}<br/>
                        - Nombre d'envois en erreur : {sendErrorCount}<br/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {/* Bouton pour retourner à /missions */}
                    <Button onClick={handleRedirect} color="primary">
                        Envoyer une nouvelle campagne
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default SendCampaign;
